exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.shake[data-v-27e8cce4] {\n    animation: shake-27e8cce4 1s cubic-bezier(.36,.07,.19,.97) both;\n    transform: translate3d(0, 0, 0);\n    backface-visibility: hidden;\n    perspective: 1000px;\n}\n@keyframes shake-27e8cce4 {\n10%, 90% {\n    transform: translateX(-1px);\n}\n20%, 80% {\n    transform: translateX(2px);\n}\n30%, 50%, 70% {\n    transform: translateX(-4px);\n}\n40%, 60% {\n    transform: translateX(4px);\n}\n}\n\n", ""]);

// exports
